export default __webpack_public_path__ + "static/media/alive-corona.8f93a374.png";